module.exports = __webpack_public_path__ + "static/img/bg2.5bc7fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg2.png
// module id = RkLc
// module chunks = 3